<!--<h1>Beau House</h1>-->



<!-- hier komen de effectieve pagina's -->
<router-outlet></router-outlet>


